// Listing modes for the Maintenance Log — Day / Flight Log (G2-875, Aaron 2026-10-14: "a new
// date-range Flight Log view (a mode) … the existing day view stays as it is").
//
// Modes are ROUTES (PATTERNS.md §"Module weight"), not `useState`. Mirrored from src/ata/modes.ts.
//
//   <base>/day         → MaintenanceLogDay (the fleet's events a day at a time, ?date=)
//   <base>/flight-log  → FlightLog (one aircraft over a date range, flight by flight; prints)

import type { ModeDescriptions } from "../components/BreadcrumbDropdownMenu";

/** Mode segment -> breadcrumb / dropdown label. Keys ARE the child route paths. */
export const MODE_LABELS: { [segment: string]: string } = {
  day: "Day",
  "flight-log": "Flight Log",
};

/** Mode segment -> the grey line under its label in the breadcrumb dropdown (BP-85). */
export const MODE_DESCRIPTIONS: ModeDescriptions = {
  day: "Fleet events by day",
  "flight-log": "Flights by date range",
};

export const DEFAULT_MODE_SEGMENT = "day";

/** `<module>.viewMode` — matches the shape used across converted modules. */
export const MODE_STORAGE_KEY = "maintenance_log.viewMode";

/** Is this a real mode segment? (hasOwnProperty, never `in`: "constructor" is not a mode.) */
export const isModeSegment = (segment: string): boolean =>
  Object.prototype.hasOwnProperty.call(MODE_LABELS, segment);

/** Redirect target for a bare visit to the module root. */
export function readRememberedModeSegment(): string {
  if (typeof window === "undefined") return DEFAULT_MODE_SEGMENT;
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(MODE_STORAGE_KEY);
  } catch {
    return DEFAULT_MODE_SEGMENT;
  }
  return stored && isModeSegment(stored) ? stored : DEFAULT_MODE_SEGMENT;
}

/** Split a live pathname into the module base and the mode segment. */
export function splitModePath(pathname: string): {
  basePath: string;
  currentMode: string;
  onMode: boolean;
} {
  const segments = pathname.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1] ?? "";
  const onMode = isModeSegment(lastSegment);
  const baseSegments = onMode ? segments.slice(0, -1) : segments;
  return {
    basePath: baseSegments.length ? "/" + baseSegments.join("/") : "",
    currentMode: onMode ? lastSegment : DEFAULT_MODE_SEGMENT,
    onMode,
  };
}
